export default "__VITE_ASSET__C4CbF8WB__"